const guacamoleUrl = process.env.REACT_APP_MALBOX_GUACURL;

export default guacamoleUrl;
